














import "./video-player.less";
import Vue from "vue";
import { Model } from "vue-property-decorator";

export default Vue.extend({
  name: "video-player",
  props: {
    showDialog: Boolean,
    videoUrl: String
  },
  data() {
    return {
      url: ""
    };
  },
  computed: {
    showModal: {
      get() {
        return (<any>this).showDialog;
      },
      set() {}
    }
  },
  watch: {
    showModal(newVal) {
      if (newVal === false) {
        this.url = "";
      } else {
        this.url = this.videoUrl;
      }
    }
  },
  methods: {}
});
